import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'twc-checkpoint-lane',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkpoint-lane.component.html',
  styleUrls: ['./checkpoint-lane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckpointLaneComponent {
  @Input() data: any[];
  @Input() leftTemplate?: TemplateRef<any>;
  @Input() rightTemplate: TemplateRef<any>;
}
